/**
 * Municípios passam pelo nosso backend, CNPJ não: o endpoint de CNPJ da BrasilAPI tem limite de
 * taxa, e proxiar colocaria todos os parceiros atrás de um IP só. Fora do nosso `api` porque aquela
 * instância manda o Bearer em todo request.
 */

import axios from 'axios'

export interface EmpresaDaBrasilApi {
  razaoSocial: string
  telefone: string
  uf: string
}

interface RespostaDaBrasilApi {
  razao_social?: string
  ddd_telefone_1?: string
  uf?: string
}

/** Devolve null quando o CNPJ não existe ou a BrasilAPI está fora — o cadastro segue na mão. */
export async function buscarEmpresaPorCnpj(cnpj: string): Promise<EmpresaDaBrasilApi | null> {
  const digitos = cnpj.replace(/\D/g, '')
  if (digitos.length !== 14) return null

  try {
    const { data } = await axios.get<RespostaDaBrasilApi>(
      `https://brasilapi.com.br/api/cnpj/v1/${digitos}`,
      { withCredentials: false }
    )
    return {
      razaoSocial: data.razao_social ?? '',
      telefone: data.ddd_telefone_1 ?? '',
      uf: data.uf ?? '',
    }
  } catch {
    return null
  }
}
